import { API_URL } from './api';

// Session ID - persistent per browser session
function getSessionId() {
  let sid = sessionStorage.getItem('visitor_session_id');
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem('visitor_session_id', sid);
  }
  return sid;
}

// Persist initial UTM/gclid params for the entire session
function getSessionParams() {
  const stored = sessionStorage.getItem('visitor_utm');
  if (stored) return JSON.parse(stored);
  return null;
}

function storeSessionParams(params) {
  sessionStorage.setItem('visitor_utm', JSON.stringify(params));
}

export function trackVisit() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utmData = {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || '',
      gclid: params.get('gclid') || '',
    };
    // Store if this is the landing page with UTM/gclid
    if (utmData.utm_source || utmData.gclid) {
      storeSessionParams(utmData);
    }
    const data = {
      page: window.location.pathname,
      session_id: getSessionId(),
      referrer: document.referrer || '',
      ...utmData,
    };
    fetch(`${API_URL}/api/track/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).catch(() => {});
  } catch {}
}

export function trackPageChange(page) {
  try {
    // Reuse stored UTM/gclid from the landing page
    const stored = getSessionParams() || {};
    const data = {
      page,
      session_id: getSessionId(),
      referrer: '',
      utm_source: stored.utm_source || '',
      utm_medium: stored.utm_medium || '',
      utm_campaign: stored.utm_campaign || '',
      utm_term: stored.utm_term || '',
      utm_content: stored.utm_content || '',
      gclid: stored.gclid || '',
    };
    fetch(`${API_URL}/api/track/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).catch(() => {});
  } catch {}
}

export function getFormSessionId() {
  let sid = sessionStorage.getItem('form_session_id');
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem('form_session_id', sid);
  }
  return sid;
}

export function trackFormStep(step, stepName) {
  try {
    const session_id = getFormSessionId();
    fetch(`${API_URL}/api/track/form-step`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id, step, step_name: stepName }),
    }).catch(() => {});
  } catch {}
}

export function trackCallClick(page) {
  try {
    fetch(`${API_URL}/api/track/call-click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: page || window.location.pathname }),
    }).catch(() => {});
  } catch {}
}

let _contactFormIds = new Set();

export function getContactFormId() {
  return crypto.randomUUID ? crypto.randomUUID() : `cf-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function trackContactFormStart(formId, page) {
  try {
    if (_contactFormIds.has(formId)) return;
    _contactFormIds.add(formId);
    fetch(`${API_URL}/api/track/contact-form`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ form_id: formId, action: 'start', page: page || window.location.pathname }),
    }).catch(() => {});
  } catch {}
}

export function trackBlogCTA(slug) {
  try {
    fetch(`${API_URL}/api/track/blog-cta`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug, session_id: getSessionId(), page: `/blog/${slug}` }),
    }).catch(() => {});
  } catch {}
}

export function trackContactFormSubmit(formId, page) {
  try {
    fetch(`${API_URL}/api/track/contact-form`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ form_id: formId, action: 'submit', page: page || window.location.pathname }),
    }).catch(() => {});
  } catch {}
}
